import { render, staticRenderFns } from "./kv-skeleton.vue?vue&type=template&id=348ce65f&scoped=true"
import script from "./kv-skeleton.vue?vue&type=script&lang=js"
export * from "./kv-skeleton.vue?vue&type=script&lang=js"
import style0 from "./kv-skeleton.vue?vue&type=style&index=0&id=348ce65f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348ce65f",
  null
  
)

export default component.exports